import { writable } from 'svelte/store';

const createMergeableStore = (initialState = {}) => {
  const { subscribe, update, set } = writable(initialState);

  return {
    subscribe,
    merge: async (newStore) => Promise.resolve(update(oldStore => ({ ...oldStore, ...newStore }))),
    reset: async () => Promise.resolve(set(initialState)),
  };
};

export const navigationStore = createMergeableStore({
  from: null,
  to: null,
  router: null,
});
